module.exports = __webpack_public_path__ + "assets/media/navigations-desktop-google-play.64666a0d.svg";